import { cn } from '@/utilities/ui'
import { colorToBackgroundClass } from '@/utilities/colors'

type Props = {
  label?: string | null
  color?: 'olive' | 'highlighter' | 'punch' | 'zest' | 'slime' | 'powder' | 'paper' | 'rock' | null
  variant: 'light' | 'dark'
  className?: string
  labelClassName?: string
  size?: 'sm' | 'md'
}

export function Eyebrow({
  label,
  color = 'punch',
  variant,
  className,
  labelClassName,
  size = 'md',
}: Props) {
  const colorClass = color ? colorToBackgroundClass[color] : ''
  return (
    <div className={cn('flex items-center gap-[20px]', className)}>
      <div>
        <div className={cn('w-[20px] h-[10px]', colorClass)} />
      </div>
      {label && (
        <label
          className={cn(
            'font-eyebrow',
            'font-weight-eyebrow',
            'leading-eyebrow',
            'tracking-eyebrow',
            size === 'sm' ? 'text-eyebrow-sm' : 'text-eyebrow-md',
            'uppercase',
            variant === 'dark' ? 'text-dark' : 'text-light',
            labelClassName,
          )}
        >
          {label}
        </label>
      )}
    </div>
  )
}
